import { render } from "./RecipeTabs.vue?vue&type=template&id=7e3ceeec&scoped=true"
import script from "./RecipeTabs.vue?vue&type=script&lang=js"
export * from "./RecipeTabs.vue?vue&type=script&lang=js"

import "./RecipeTabs.vue?vue&type=style&index=0&id=7e3ceeec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3ceeec"]])

export default __exports__